<section class="sponsor-dialog-container">
  <button type="button" (click)="closeDialog()" class="icon-collapse">
    Collapse
    <mat-icon svgIcon="arrow-line-right" />
  </button>
  <img ngSrc="assets/images/sponsors/partners/mxd.svg" height="225" width="1000" alt="">
  <div>
    <h2>Build Job-Ready Skills With {{ sponsor.name }}</h2>
    <p>{{ sponsor.name }} provides employer-aligned training designed to build real-world manufacturing and
      cybersecurity skills. To
      take
      these courses, you’ll need to register on the {{ sponsor.name }} training site. Once your account is created,
      you’ll get full
      access to hands-on modules, credentials, and tools that help you stand out to hiring organizations.</p>
    <p
      role="button"
      tabindex="0"
      (keydown.enter)="openExternalPage()"
      (keydown.space)="$event.preventDefault(); openExternalPage()"
      ><a (click)="openExternalPage()" (keydown.enter)="openExternalPage()" role="button" tabindex="0" class="create-account">Create an account</a> on {{ sponsor.name }}’s
      virtual training
      center to access the training.</p>
  </div>
  <div class="career-courses">
    @for (feature of pathwayFeatures; track feature.title) {
      <cpd-sponsor-course-card [sponsor]="sponsor" [cardInfo]="feature" (onCardClicked)="openExternalPage()" />
    }
  </div>
</section>
